<template>
    <div class='container'>
      <h2>智鼎云隐私协议</h2>
      <p>智鼎云非常重视保护用户的隐私和个人信息保护。您的信任对智鼎云非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，竭尽全力通过合理有效的信息安全技术及管理流程，防止您的信息泄露、损毁、丢失。我们将在产品或服务开发的各个环节，综合法律、产品、设计等多方因素，融入隐私保护的理念。希望您仔细阅读《隐私声明》（以下简称“本声明”），详细了解我们对信息的收集、使用方式，以便您更好地了解我们的服务并作出适当的选择。</p>
      <div v-for="item in detail">
        <h3>{{item.title}}</h3>
        <div v-for="item2 in item.content">
          <p>{{item2}}</p>
        </div>
      </div>
    </div>
</template>

<script>
import {Agreement} from './agree'
export default {
    name: '',
    components: {},
    data () { return {
      detail:Agreement
    }},
    methods: {
        init () {},
    },
    created () {
      
      this.init();
    },
}
</script>

<style lang='less' scoped>
@import '~style/index';
.container{
  padding:50px;

}
h2{
  text-align: center;
  margin-bottom:50px;
}
h3{
  margin:10px;
}
p{
  text-indent: 2em;

}
</style>